import { Drawer, DrawerContent, DrawerTrigger } from "../../shadcn/ui/drawer";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../shadcn/ui/popover";

import { cn } from "@punchup/utils/cn";
import { useIsDesktop } from "@punchup/utils/hooks";

interface PopoverOrDrawerProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  trigger: React.ReactNode;
  className?: string;
  align?: "start" | "center" | "end";
  side?: "top" | "right" | "bottom" | "left";
  sideOffset?: number;
}

export function PopoverOrDrawer({
  isOpen,
  onOpenChange,
  children,
  trigger,
  className,
  align = "center",
  side = "bottom",
  sideOffset = 4,
}: PopoverOrDrawerProps) {
  const isDesktop = useIsDesktop();

  const handleOpenChange = (open: boolean) => {
    // Ignore calls where the value hasn't changed
    // This prevents vaul drawer from closing itself during mount
    if (open === isOpen) {
      return;
    }

    onOpenChange(open);
  };

  if (!isDesktop) {
    return (
      <Drawer open={isOpen} onOpenChange={handleOpenChange}>
        <DrawerTrigger asChild>{trigger}</DrawerTrigger>
        <DrawerContent className={cn("max-h-[85vh] p-6", className)}>
          <div className="max-h-[75dvh] w-full pt-2 pb-16 overflow-y-scroll">
            {children}
          </div>
        </DrawerContent>
      </Drawer>
    );
  }

  return (
    <Popover open={isOpen} onOpenChange={handleOpenChange}>
      <PopoverTrigger asChild>{trigger}</PopoverTrigger>
      <PopoverContent
        align={align}
        side={side}
        sideOffset={sideOffset}
        className={cn("w-80", className)}
      >
        {children}
      </PopoverContent>
    </Popover>
  );
}
